<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet />
      <ion-tab-bar slot="bottom" id="app-tab-bar">
        <ion-tab-button tab="home" href="/page/home">
          <ion-icon :icon="menu"></ion-icon>
          <ion-label>Menu</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="pengguna" href="/pengguna">
          <ion-icon :icon="person"></ion-icon>
          <ion-label>Pengguna</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="logout" @click.prevent="logOut()">
          <ion-icon :icon="exit"></ion-icon>
          <ion-label>Logout</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup>
import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLabel,
  IonIcon,
  IonPage,
  IonRouterOutlet,
  alertController,
} from "@ionic/vue";
import { exit, menu, person } from "ionicons/icons";
import { useRouter } from "vue-router";
import { getAuth, signOut } from "firebase/auth";

const auth = getAuth();
const router = useRouter();

const logOut = async () => {
  const alert = await alertController.create({
    cssClass: "my-custom-class",
    header: "Confirm!",
    mode: "ios",
    message: "Confirm Logout?",
    buttons: [
      {
        text: "Cancel",
        role: "cancel",
        cssClass: "secondary",
        handler: () => {
          console.log("Confirm Cancel");
        },
      },
      {
        text: "Logout",
        handler: async () => {
          try {
            await signOut(auth);
            console.log("Logged out successfully");

            // Bersihkan semua data lokal
            localStorage.clear();
            sessionStorage.clear();

            // Redirect ke halaman login setelah logout
            router.push({ name: "login" }).then(() => {
              // Bersihkan riwayat sehingga pengguna tidak dapat kembali ke halaman sebelumnya
              router.go(0);
            });
          } catch (error) {
            console.error("Logout error", error);
          }
        },
      },
    ],
  });
  await alert.present();
};
</script>

<style scoped>
ion-tab-bar {
  position: relative;
  bottom: 0;
  width: 100%;
  height: 60px;
  --background: #f3f3f3;
}
ion-tab-bar ion-tab-button {
  font-size: 13px;
  --color-selected: var(--ion-color-primary);
}
ion-tab-bar ion-tab-button ion-icon {
  font-size: 1.5rem;
}
</style>
